import { Keyword, LengthPercentage } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Selective } from "@siteimprove/alfa-selective";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
const parse = either(Keyword.parse("auto", "from-font"), LengthPercentage.parse);
const longhand = Longhand.of(Keyword.of("auto"), parse, (value, style) => value.map((value) => Selective.of(value)
    .if(LengthPercentage.isLengthPercentage, LengthPercentage.resolve(Resolver.lengthPercentage(style.computed("font-size").value, style)))
    .get()));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-thickness}
 * @internal
 */
export default longhand;
//# sourceMappingURL=text-decoration-thickness.js.map